import { render, staticRenderFns } from "./ShippingPolicy.vue?vue&type=template&id=331e608a"
import script from "./ShippingPolicy.vue?vue&type=script&lang=js"
export * from "./ShippingPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports